import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonTitle, IonToolbar } from '@ionic/react'
import { chevronBackOutline } from 'ionicons/icons'
import React, { BaseSyntheticEvent, useEffect } from 'react'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import TermsAndConditionsContent from './termsAndConditionsContent'
import { AppRouterConstants } from '../../../components/appRouter/AppRouter.constants'
import './termsAndConditions.css'
import { getUserSelector } from '../../user/selectors'
import { useSelector } from 'react-redux'
import { AuthenticationService } from '../../login/services/authentication.service'
import Logger from '../../../services/logger.service'

const TermsAndConditions: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const user = useSelector(getUserSelector)

  const allowSecureRoutes = AuthenticationService.allowSecureRoutes(user)
  useEffect(() => {
    if (!allowSecureRoutes) {
      Logger.warn('User is not authenticated. Redirecting to index route.')
      history.push(AppRouterConstants.INDEX_ROUTE)
    }
  }, [allowSecureRoutes])

  const onBackClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    history.push(AppRouterConstants.SIGNATURE_ROUTE)
  }

  return (
    <>
      <IonPage id='TermsAndConditionsPage'>
        <PCRHeader />
        <IonHeader>
          <IonToolbar className='toolbarBorder' color='light'>
            <IonButtons slot='start'>
              <IonButton data-testid='Back' color='primary-alt' onClick={onBackClick}>
                <IonIcon icon={chevronBackOutline} />
                {t('common.buttons.Back')}
              </IonButton>
            </IonButtons>
            <IonTitle data-testid='HeaderTitle'>{t('signature.termsAndConditions')}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent id='main-pn-content' color='light' fullscreen>
          <TermsAndConditionsContent />
        </IonContent>
      </IonPage>
    </>
  )
}

export default TermsAndConditions
